import React from "react";
import EstablishedImg from "../../assets/Established.png";
import { FaUserCog } from "react-icons/fa";
import { LuMoveRight } from "react-icons/lu";

export const Established = () => {
    return (
        <section className="w-full md:mt-0 mt-14">
            <div
                className="mx-auto rounded-2xl overflow-hidden relative h-96 sm:h-96 md:h-[400px] lg:h-[500px] flex items-center justify-center"
                style={{
                    backgroundImage: `url(${EstablishedImg})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                {/* Overlay */}
                <div className="absolute inset-0 bg-white/60 backdrop-blur-sm"></div>
                <div className="max-w-7xl mx-auto px-6 relative z-10">
                {/* Content */}
                <div className="relative z-10 p-6 sm:p-10 md:p-14 text-center md:text-left">

                    {/* Icon */}
                    <div className="flex justify-center md:justify-start mb-4">
                        <FaUserCog className="text-3xl md:text-5xl text-black" />
                    </div>

                    {/* Small Title */}
                    <p className="text-sm mb-2 text-center font-semibold">Established</p>

                    {/* Heading */}
                    <h2 className="text-2xl sm:text-4xl md:text-6xl font-bold text-gray-900 leading-tight max-w-5xl mx-auto md:mx-0">
                        Precision engineering for industrial infrastructure
                    </h2>

                    {/* Description */}
                    <p className="mt-4 text-gray-900  text-sm max-w-5xl text-center sm:text-base md:mx-0">
                        Vetri Pipeline Systems has spent years perfecting the craft of industrial construction.
                        We know what it takes to build systems that last, that hold pressure, and that do the
                        work without complaint.
                    </p>

                    {/* Button */}
                        <div className="mt-6 flex justify-center">
                            <button  className="group bg-orange-500 text-white px-6 py-3 rounded-lg hover:bg-orange-600 transition flex items-center gap-2 shadow-md">

                                <span className="font-medium">Know More</span>

                                <LuMoveRight
                                    className="transition-transform   -rotate-45 group-hover:rotate-0 duration-300 group-hover:translate-x-1"
                                    size={18}
                                />

                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};